module.exports = __webpack_public_path__ + "71ae32b205602a0996dd1412fe5f2739.svg";